<template>
  <sui-page>
    <sui-page-header :pageId="this.$options.name" />
    <sui-page-contents>
      <div class="comm_scr_wrap">
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_TASK_TYPE')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-5">
            <cmp-task-id-select
              ref="taskIdSelect"
              :pageId="this.$options.name"
              :default1LevelOption="'all'"
              :default2LevelOption="'all'"
              :default3LevelOption="'all'"
              @select-changed="onChangeBizCodes"
            />
          </div>
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_SEARCH_COND')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-5">
            <sui-code-select
              ref="condType"
              :selected="selectedValues.COD_ROLE_SRCH_COND"
              codeId="COD_ROLE_SRCH_COND"
              :defaultOption="'all'"
              @loaded="onCondTypeLoaded"
            />
            <div class="comp_spacing" />
            <sui-text-field
              v-model="condContent"
              maxlength="50"
              @keyup.enter="onSearch"
              @keyup="onKeyUpInput"
            />
          </div>
        </div>
        <div class="btn_wrap">
          <!-- <sui-button type="button" class="comm_btn_scr" @click="onPopup">ROLE 선택 POPUP TEST</sui-button> -->
          <sui-button
            type="button"
            class="comm_btn_Reset"
            @click="onReset"
          >
            {{ $t("MSG_BTN_RESET") }}
          </sui-button>
          <sui-button
            v-permission:read="'PGE_CMA_00001'"
            type="button"
            class="comm_btn_Scr"
            @click="onSearch"
          >
            {{ $t("MSG_BTN_SEARCH") }}
          </sui-button>
        </div>
      </div>
      <div class="mrB30" />
      <div class="comm_shut_wrap">
        <div class="inbox">
          <sui-s-grid
            ref="grdList"
            :headers="columnRole"
            :data-source="dsData"
            :options="options"
            :showRowsPerPageControl="false"
            :initialRowsPerPage="10"
            @grid:selected="onSelectGrid"
          />
        </div>
        <div class="emptybox" />
        <div class="inbox">
          <div class="mrB45" />
          <sui-page-tab-box-type
            :tabItems="tabItems"
            :defaultTabIndex="defaultTabIndex"
            :setCurrentTabComponent="onSetCurrentTabComponent"
            @change-tab-idx="onChangeTabIdx"
          >
            <container
              :is="currentTabComponent"
              ref="tabPage"
              :pageId="this.$options.name"
              :selectedGridRowData="selectedGridRowData"
              :selectedPageId="selectedPageId"
              :isDataNull="isNullData"
              @onClearSelectionMainGrid="onClearSelectionMainGrid"
              @onSearchClick="onTabSearch"
              @onCallUserPopup="onCallUserPopup"
              @onCallPagePopup="onCallPagePopup"
              @onCallDtsvcPopup="onCallDtsvcPopup"
              @page-deactivate="handleChildDeactivated" 
              @page-activate="handleChildActivated"
            />
          </sui-page-tab-box-type>
        </div>
      </div>
      <sui-popup
        v-model="showUserPopup"
        :title="$t('MSG_TIT_ROLE_USER_GROUP_REG')"
      >
        <p01
          :parentPageId="this.$options.name"
          :dataList="dataList"
          @save="onUserPopupSaveClicked"
          @cancel="onUserPopupCancelClicked"
        />
      </sui-popup>
      <sui-popup
        v-model="showPagePopup"
        :title="$t('MSG_TIT_ROLE_PAGE_REG')"
      >
        <p02
          :parentPageId="this.$options.name"
          :dataList="dataList"
          @save="onPagePopupSaveClicked"
          @cancel="onPagePopupCancelClicked"
        />
      </sui-popup>
      <sui-popup
        v-model="showDtsvcPopup"
        :title="$t('MSG_TIT_ROLE_DTSVC_REG')"
      >
        <p03
          :parentPageId="this.$options.name"
          :dataList="dataList"
          @save="onDtsvcPopupSaveClicked"
          @cancel="onDtsvcPopupCancelClicked"
        />
      </sui-popup>
    </sui-page-contents>
  </sui-page>
</template>
<script>
import BasePage from '~cm/components/BasePage';
import p01 from './components/PGE_CMA_00001_P01';
import p02 from './components/PGE_CMA_00001_P02';
import p03 from './components/PGE_CMA_00001_P03';
import tab01 from './components/PGE_CMA_00001_T01';
import tab02 from './components/PGE_CMA_00001_T02';
import tab03 from './components/PGE_CMA_00001_T03';
import tab04 from './components/PGE_CMA_00001_T04';
import {urDataSet} from 'uidev-component/index.js';
import urDataGrid from '@uidev/grid/urDataGrid/urDataGrid';

export default {
  name: 'PGE_CMA_00001', // eslint-disable-line vue/name-property-casing
  extends: BasePage,
  components: {
    urDataGrid:urDataGrid,
    p01,
    p02,
    p03,
    tab01,
    tab02,
    tab03,
    tab04,
  },
  data() {
    return {
      tabItems: [
        {
          tabTitle: this.$t('MSG_TIT_ROLE_MGT'),
          component: tab01, // pageID
        },
        {
          tabTitle: this.$t('MSG_TXT_USER_GROUP'),
          component: tab02,
        },
        {
          tabTitle: this.$t('MSG_TXT_PAGE'),
          component: tab03,
        },
        {
          tabTitle: this.$t('MSG_TXT_DTSVC'),
          component: tab04,
        },
      ],
      isNullData: false,
      showUserPopup: false,
      showPagePopup: false,
      showDtsvcPopup: false,
      currentTabComponent: 'tab01',
      defaultTabIndex: 0,
      tabIndex: 0,
      condContent: '',
      selectedPageId: '',
      selectedGridRowData: {},
      selectedBizCode: [],
      selectedValues: {
        // form input 값등이 저장될 변수
        COD_ROLE_SRCH_COND: { key: '', label: '' },
      },
      oldRowIndex: -1,
      condTypeKey: '',
      searchFieldOldText: '',
      localdata: [],
      dsData: new urDataSet(),
      options: {
        infinityScroll: true,
        noBaseInfo: false,
        internalPaging: false,
      },
    };
  },
  created() {
    this.dataList = [];
    this.columnRole = [
      {
        value: 'roleId',
        text: this.$t('MSG_TXT_ROLE_ID'),
        width: 100,
      },
      {
        value: 'roleName',
        text: this.$t('MSG_TXT_ROLE_NAME'),
        width: 150,
      },
      {
        value: 'roleNickName',
        text: this.$t('MSG_TXT_ROLE_ALIAS'),
        width: 150,
      },
      {
        value: 'taskName',
        text: this.$t('MSG_TXT_TASK_TYPE'),
      },
    ];
  },
  computed: {
    // 계산된 속성, date pickproperty로 사용가능
  },
  watch: {
    // data 변경시 특정 함수를 호출 해야 하는 경우(async 등)
  },
  mounted() {
    //this.dsData.$on(this.dsData.EVENTS.SELECTION_CHANGED, this.onSelectGrid);
  },
  beforeUpdate() {
    // data 변경전 DOM 정보가 필요한 경우
  },
  updated() {
    // data 변경후 DOM 정보가 필요한 경우
  },
  beforeDestroy() {
    // 이벤트 핸들러 및 사용한 서드 파티 라이브러리 자원 반환
    // if (this.dsData) {
    //   this.dsData.$off(this.dsData.EVENTS.SELECTION_CHANGED, this.onSelectGrid);
    // }
  },
  destroyed() {
    // 남아 있는 자원 반환
  },
  methods: {
    conFirm(type, value, subValue) {
      utils.messageBox(type, value, subValue, this.onClose);
    },
    onClose() {
      console.log('onConfirm');
    },
    onSetCurrentTabComponent(component) {
      this.currentTabComponent = component;
    },
    onChangeTabIdx(idx) {
      this.currentTabComponent = this.tabItems[idx].component;
    },
    onChange() {
      console.log('ok');
    },
    onReset() {
      this.$refs.condType.reset();
      this.selectedValues.COD_ROLE_SRCH_COND.key = this.condTypeKey;
      this.condContent = '';
      this.$refs.taskIdSelect.reset();
      this.selectedBizCode = [];
    },
    onSearch() {
      // 구분 코드
      let taskId = '';
      if (this.selectedBizCode.length === 3) {
        if (this.selectedBizCode[2].key !== 'ALL') {
          taskId = utils.trim(this.selectedBizCode[2].key);
        } else if (this.selectedBizCode[1].key !== 'ALL') {
          taskId = utils.trim(this.selectedBizCode[1].key);
        } else if (this.selectedBizCode[0].key !== 'ALL') {
          taskId = utils.trim(this.selectedBizCode[0].key);
        }
      }

      const condTypeCode = utils.trim(this.selectedValues.COD_ROLE_SRCH_COND.key);

      const queryParams = {
        taskId: taskId || '',
        searchCond: condTypeCode || '',
        searchWord: utils.trim(this.condContent) || '',
      };

      http.request(this.$options.name, 'DTS_CMA_00001', {
        query: queryParams,
      }).then(res => {
        if (res.data) {
          // sonarcube codesmell 대응
          // if (res.data != null) {
            if (res.data.length > 0) {
              this.$refs.grdList.resetSelect();
              this.dsData.setData(res.data);
              this.oldRowIndex = 0;
              this.isNullData = false;
              //this.$refs.tabPage.initData();
            } else {
              this.oldRowIndex = -1;
              this.isNullData = true;
              this.selectedGridRowData = {};
              this.selectedPageId = '';
              //this.$refs.tabPage.initData();
              this.dsData.setData([]);
            }
          } else {
            this.dsData.setData([]);
            this.isNullData = true;
            this.selectedGridRowData = {};
            this.selectedPageId = '';
            //this.$refs.tabPage.initData();
          }
        // }
      }).catch(error => {
        console.log(error);
      });
    },
    onClearSelectionMainGrid() {
      // this.dsData.clearSelection();
      this.$refs.grdList.resetSelect();
      this.selectedGridRowData = {};
    },
    onTabSearch() {
      this.onSearch();
    },
    changeTabIndex() {
      this.tabIndex = this.tabIndex + 1;
      this.$refs.tab.changeIdx(this.tabIndex % 2);
    },
    onSelectGrid(row) {
      if (!utils.isEmpty(row)) {
        this.selectedGridRowData = row;
        this.selectedPageId = this.selectedGridRowData ? this.selectedGridRowData.pageId : '';
      } else {
        this.selectedGridRowData = {};
        this.selectedPageId = '';
      }
    },
    onCondTypeLoaded(optionsList) {
      this.condTypeKey = optionsList[0].key;
      this.selectedValues.COD_ROLE_SRCH_COND.key = optionsList[0].key;
    },
    onKeyUpInput() {
      const searchFieldNewText = this.condContent;

      if (utils.isEmpty(searchFieldNewText) === false) {
        if (utils.isExistSpecialChar(searchFieldNewText) === true) {
          this.conFirm('error', this.$t('MSG_ALT_NO_SPECL_CHAR'), null);
          this.condContent = this.searchFieldOldText;
        } else {
          this.searchFieldOldText = searchFieldNewText;
        }
      }
    },
    onChangeBizCodes(optList) {
      this.selectedBizCode = optList;
    },
    onPopup() {
      utils.openLayerPopup('PGE_CMA_00002', this.onPagePopupClose, {
        pageInitialData: {},
        size: 'md',
      });
    },
    onPagePopupClose(data) {
      console.log(data);
    },
    onUserPopupSaveClicked(dataInfo) {
      console.log(dataInfo);

      this.showUserPopup = false;

      this.selectedGridRowData = this.dsData.getSelected()[0];
      //      this.selectedPageId = this.selectedGridRowData ? this.selectedGridRowData.pageId : '';
    },
    onUserPopupCancelClicked(dataInfo) {
      console.log(dataInfo);
      this.showUserPopup = false;
    },
    onPagePopupSaveClicked(dataInfo) {
      console.log(dataInfo);

      this.showPagePopup = false;

      this.selectedGridRowData = this.dsData.getSelected()[0];
      // this.selectedPageId = this.selectedGridRowData ? this.selectedGridRowData.pageId : '';
    },
    onPagePopupCancelClicked(data) {
      console.log(data);
      this.showPagePopup = false;
    },
    onDtsvcPopupSaveClicked(dataInfo) {
      console.log(dataInfo);
      this.showDtsvcPopup = false;
      this.selectedGridRowData = this.dsData.getSelected()[0];
    },
    onDtsvcPopupCancelClicked(data) {
      console.log(data);
      this.showDtsvcPopup = false;
    },
    onCallUserPopup(data) {
      if (data.length > 0) {
        this.dataList = data;
      }
      this.showUserPopup = true;
    },
    onCallPagePopup(data) {
      if (data.length > 0) {
        this.dataList = data;
      }
      this.showPagePopup = true;
    },
    onCallDtsvcPopup(data) {
      if (data.length > 0) {
        this.dataList = data;
      }
      this.showDtsvcPopup = true;
    },
  },
};
</script>
<style scoped>
</style>
